// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import AuthenticationAPI from 'common/modules/authentication/services/AuthenticationAPI';
import ForgotPasswordPage from 'common/modules/authentication/resetPassword/ForgotPasswordPage';
import type { AppState } from '../../../types/State';

type Props = {
  isAuthenticated: boolean,
}

function StationForgotPasswordPage(props: Props) {
  const { isAuthenticated } = props;
  return (
    <ForgotPasswordPage
      isAuthenticated={isAuthenticated}
      onResetPassword={email => AuthenticationAPI.requestStationPasswordReset(email)}
    />
  );
}

function mapStateToProps(state: AppState) {
  return {
    isAuthenticated: state.session.isAuthenticated,
  };
}

export default connect(mapStateToProps)(StationForgotPasswordPage);



// WEBPACK FOOTER //
// ./src/statsradio/modules/authentication/resetPassword/StationForgotPasswordPage.js